<!-- loading spinner -->
<div *ngIf="isLoading" class="text-center m-3">
  <app-spinner size="l" dark="true"></app-spinner>
  <p>{{'LOADING'|translate}}</p>
</div>

<!-- data -->
<ng-container *ngIf="!isLoading">

  <div *ngIf="hasNoPermission" class="alert alert-warning" [translate]="typePrefix + '_INFO_NO_PREMISSION'"
    [translateParams]="{value: id}"></div>

  <ng-container *ngIf="!hasNoPermission">
    <div class="card bg-light mb-3">
      <div class="card-body">
        <h5 class="card-title">{{typePrefix|translate}}</h5>
        <p class="card-text">
          <span [innerHTML]="data.Ressource.Text"></span>
          <ng-container *ngIf="data.Ressource.NumberPersons">
            <br>{{data.Ressource.NumberPersons}} {{'PERSONS'|translate}}
          </ng-container>
        </p>
      </div>
    </div>

    <div *ngIf="data.Infrastructure" class="card bg-light mb-3">
      <div class="card-body">
        <h5 class="card-title">{{'INFRASTRUCTURE'|translate}}</h5>
        <p class="card-text" [innerHTML]="data.Infrastructure"></p>
      </div>
    </div>

    <div *ngIf="data.Remark" class="card bg-light mb-3">
      <div class="card-body">
        <h5 class="card-title">{{'NOTE'|translate}}</h5>
        <p class="card-text" [innerHTML]="data.Remark"></p>
      </div>
    </div>

    <div *ngIf="data.RessourceUrl" class="card bg-light mb-3">
      <div class="card-body">
        <h5 class="card-title">{{'MORE_INFORMATION'|translate}}</h5>
        <p class="card-text">
          <a [href]="data.RessourceUrl" target="_blank">{{'ADDITIONAL_INFORMATION'|translate}}</a>
        </p>
      </div>
    </div>

    <div *ngIf="data.Building || data.Address" class="card bg-light">
      <div class="card-body">
        <h5 class="card-title">{{'LOCATION'|translate}}</h5>

        <p>
          {{data.Site}}<br />
          <a *ngIf="data.Building.Url" [href]="data.Building.Url" target="_blank">{{data.Building.Designation}}</a>
          <span *ngIf="!data.Building.Url">{{data.Building.Designation}}</span>
          <span *ngIf="data.Building.Floor">, {{data.Building.Floor}}</span>
        </p>

        <table>
          <tr>
            <td>
              <p *ngIf="data.Address" [innerHTML]="data.Address"></p>
            </td>
            <td *ngIf="mapLink" class="p-3">
              <app-button text="{{'OPEN_GOOGLE_MAPS'|translate}}" icon="map-marker" hideText="true"
                (click)="onClickMapLink($event)"></app-button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </ng-container>
</ng-container>